import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Shield, Phone, Mail, CheckCircle, ArrowLeft } from "lucide-react";

export default function ToolInsureCo() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-green-900 to-green-950">
      {/* Header */}
      <header className="bg-green-800 border-b border-green-700">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center">
              <Shield className="w-6 h-6 text-green-600" />
            </div>
            <span className="text-2xl font-bold text-white">ToolInsureCo</span>
          </div>
          <Badge className="bg-yellow-500 text-black font-bold">
            TOOLIO Partner
          </Badge>
        </div>
      </header>

      <main className="p-4 lg:p-8 max-w-4xl mx-auto">
        {/* Demo Notice */}
        <Card className="bg-yellow-500/20 border-yellow-500/50 mb-6">
          <CardContent className="p-4 text-center">
            <p className="text-yellow-300 font-semibold">
              This is a demo insurance partner page for testing the TOOLIO referral system
            </p>
          </CardContent>
        </Card>

        {/* Hero */}
        <div className="text-center mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Protect Your Tools with <span className="text-green-400">ToolInsureCo</span>
          </h1>
          <p className="text-green-200 text-lg max-w-2xl mx-auto">
            The UK's trusted tool insurance provider. Special rates for TOOLIO members!
          </p>
        </div>

        {/* Special Offer */}
        <Card className="bg-green-800 border-green-600 mb-8">
          <CardContent className="p-8 text-center">
            <Badge className="bg-primary text-black text-lg px-4 py-2 mb-4">
              TOOLIO Exclusive
            </Badge>
            <h2 className="text-4xl font-bold text-white mb-2">
              15% OFF
            </h2>
            <p className="text-green-200 text-lg mb-6">
              Your first year of tool insurance
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
              <div className="flex items-center gap-2 justify-center text-white">
                <CheckCircle className="w-5 h-5 text-green-400" />
                <span>Theft Coverage</span>
              </div>
              <div className="flex items-center gap-2 justify-center text-white">
                <CheckCircle className="w-5 h-5 text-green-400" />
                <span>Accidental Damage</span>
              </div>
              <div className="flex items-center gap-2 justify-center text-white">
                <CheckCircle className="w-5 h-5 text-green-400" />
                <span>Worldwide Cover</span>
              </div>
            </div>
            <Button className="bg-white text-green-800 hover:bg-green-100 text-lg px-8 py-6">
              Get Your Quote
            </Button>
          </CardContent>
        </Card>

        {/* Coverage Info */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <Card className="bg-green-800/50 border-green-700">
            <CardHeader>
              <CardTitle className="text-white">What's Covered</CardTitle>
            </CardHeader>
            <CardContent className="space-y-3">
              <div className="flex items-center gap-2 text-green-200">
                <CheckCircle className="w-4 h-4 text-green-400" />
                <span>Power tools & hand tools</span>
              </div>
              <div className="flex items-center gap-2 text-green-200">
                <CheckCircle className="w-4 h-4 text-green-400" />
                <span>Theft from vehicle or site</span>
              </div>
              <div className="flex items-center gap-2 text-green-200">
                <CheckCircle className="w-4 h-4 text-green-400" />
                <span>Accidental damage</span>
              </div>
              <div className="flex items-center gap-2 text-green-200">
                <CheckCircle className="w-4 h-4 text-green-400" />
                <span>New for old replacement</span>
              </div>
            </CardContent>
          </Card>
          <Card className="bg-green-800/50 border-green-700">
            <CardHeader>
              <CardTitle className="text-white">Contact Us</CardTitle>
            </CardHeader>
            <CardContent className="space-y-3">
              <div className="flex items-center gap-2 text-green-200">
                <Phone className="w-4 h-4 text-green-400" />
                <span>0800 123 4567</span>
              </div>
              <div className="flex items-center gap-2 text-green-200">
                <Mail className="w-4 h-4 text-green-400" />
                <span>quotes@toolinsureco.demo</span>
              </div>
              <p className="text-green-300 text-sm mt-4">
                Mon-Fri: 9am - 5pm
              </p>
            </CardContent>
          </Card>
        </div>

        {/* Back to TOOLIO */}
        <div className="text-center">
          <Link to="/insurance">
            <Button variant="outline" className="border-green-500 text-green-300 hover:bg-green-800">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to TOOLIO
            </Button>
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="mt-12 py-6 border-t border-green-800 text-center text-green-400 text-sm">
        <p>ToolInsureCo is a demo page for testing TOOLIO referral tracking</p>
      </footer>
    </div>
  );
}
